import { render } from "./HowWeWorkComp.vue?vue&type=template&id=5b86bd45"
import script from "./HowWeWorkComp.vue?vue&type=script&lang=js"
export * from "./HowWeWorkComp.vue?vue&type=script&lang=js"

import "./HowWeWorkComp.vue?vue&type=style&index=0&id=5b86bd45&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__